// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    qtyOrdered?: number;
    unitOfMeasure?: string;
    isQty?: boolean;
};

type HandlerType = Handler<Parameter>;

export const UpdateQuickViewProductQtyOrdered: HandlerType = (props: any) => {
    if (props.parameter.isQty) {
        props.dispatch({
            type: "QuickView/UpdateQuantity",
            qtyOrder: props.parameter.qtyOrdered,
        });
    }
};

export const UpdateQuickViewProductUnitOfMeasure = (props: any) => {
    if (!props.parameter.isQty) {
        props.dispatch({
            type: "QuickView/UpdateUnitOfMeasure",
            uom: props.parameter.unitOfMeasure,
        });
    }
};

export const chain = [UpdateQuickViewProductQtyOrdered, UpdateQuickViewProductUnitOfMeasure];

const updateQuickViewProduct = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateQuickViewProduct");
export default updateQuickViewProduct;
